import PropTypes from "prop-types";
import React, { useState } from "react";

import styled from "styled-components/macro";

import MemberSearch from "./MemberSearch";
import SearchResults from "./SearchResults";

AddMember.propTypes = {
  signupItemID: PropTypes.number,
  isFull: PropTypes.bool,
  expired: PropTypes.bool,
  setSuccessMessage: PropTypes.func,
  showPopover: PropTypes.bool,
  closePopover: PropTypes.func,
};

export default function AddMember({
  setSuccessMessage,
  signupItemID,
  showPopover,
  closePopover,
}) {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResultData, setSearchResultData] = useState(null);

  return (
    <>
      <HelpText>Search for a member to sign them up for this item.</HelpText>
      <SearchContent>
        <MemberSearch
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          setSearchResultData={setSearchResultData}
          triggerInputFocus={showPopover}
          signupItemID={signupItemID}
        />

        <SearchResults
          data={searchResultData}
          signupItemID={signupItemID}
          closePopover={closePopover}
          setSuccessMessage={setSuccessMessage}
        />
      </SearchContent>
    </>
  );
}

const HelpText = styled.div`
  padding: 8px;
  font-size: 14px;
  line-height: 17px;
`;

const SearchContent = styled.div``;
